define('bxStripComponents',[
  'jquery',
  'modernizr',
  'bxStrip'
], function (
  $,
  modernizr,
  BxStrip
) {
  var __isTouch = modernizr.touch;

  $(document).ready(function () {
    var $vehicleStrip = $('.component-strip-vehicle');
    var $galleryWrap = $('.gallery-wrap');

    // Builds vehicle-strip bxStrip slider
    if ($vehicleStrip.length) {
      var vehicle_strip = new BxStrip({
        $component: $vehicleStrip,
        $slider: $('.vehicle-slider'),
        bxoptions: {
          desktop: {
            infiniteLoop: false,
            slideWidth: 1000000,
            minSlides: 5,
            maxSlides: 5,
            slideMargin: 10,
            onSliderLoad: function () {
              var $boxPagerItem = $('.component-strip-vehicle .bx-pager-link');
              $boxPagerItem.off().on('click', function () {
                if (__isTouch) {
                  return false;
                }
              });
            }
          },
          tablet: {
            infiniteLoop: false,
            slideWidth: 1000000,
            minSlides: 4,
            maxSlides: 4,
            slideMargin: 10,
            onSliderLoad: function () {
              var $boxPagerItem = $('.component-strip-vehicle .bx-pager-link');
              $boxPagerItem.off().on('click', function () {
                if (__isTouch) {
                  return false;
                }
              });
            }
          },
          phone: {
            infiniteLoop: false,
            slideWidth: 1000000,
            minSlides: 3,
            maxSlides: 3,
            slideMargin: 10,
            onSliderLoad: function () {
              var $boxPagerItem = $('.component-strip-vehicle .bx-pager-link');
              $boxPagerItem.off().on('click', function () {
                if (__isTouch) {
                  return false;
                }
              });
            }
          }
        }
      });
    }

    // Builds gallery-wrap bxStrip slider
    if ($galleryWrap.length) {
      var gallery = new BxStrip({
        $component: $galleryWrap,
        $slider: $('.gallery-slider'),
        bxoptions: {
          useCSS: false,
          mode:'fade',
          pager: false,
          nextSelector: '.gallery-next',
          prevSelector: '.gallery-prev',
          onSliderLoad: function () {
            var $boxPagerItem = $('.gallery-wrap .bx-pager-link');
            // GST-465
            var $slides = $('.gallery-slider .slide');
            if ($slides && $slides.length > 1) {
              $('.gallery-prev.bx-prev-large').css('display', 'block');
              $('.gallery-next.bx-next-large').css('display', 'block');
            }
            $boxPagerItem.off().on('click', function () {
              if (__isTouch) {
                return false;
              }
            });
          }
        }
      }, false);
    }
  });
});

